import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setWatchHistoryVideos } from '@/store/slices/dashboard/watchHistorySlice';
import { RootState } from '@/store/index';
import { getHistoryVideosApiCall } from '@/services/api';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import HistoryFavLoader from '@/pages/dashboard/loaders/historyFavLoader'
import { cookieProvider } from '@/providers/CookieProvider'
import './history.css';
import { addCurrentThemeClassToEle } from '@/utils';

export default function History(props: any) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { dashboard } = useLocalTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [visibleCount, setVisibleCount] = useState(4); // Show 4 videos at a time

    const historyVideos = useSelector((state: RootState) => state.watchHistoryReducer.watchHistoryVideos);
    const dashboardDetails = useSelector((state: RootState) => state.dashboardDetailsReducer.dashboardDetails);
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    const noHistoryRef = useRef<HTMLDivElement>(null);

    const getHistoryVideos = async () => {
        dispatch(setWatchHistoryVideos([])); // to handle the continer auto scale when page loads
        const historyDetails = await getHistoryVideosApiCall();
        if (historyDetails.data && historyDetails.status) {
            setIsLoading(false);
            dispatch(setWatchHistoryVideos(historyDetails.data));
            // dispatch(setWatchHistoryVideos([])); // For testing empty state
        }
    };

    // debug
    // const updateCookie = () => {
    //     // alert('g')
    //     // setTimeout(() => {
    //     //     cookieProvider.set('authToken', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY2ZTY3YTc1YjIyMWI5NzNlZjY4MGI1MyIsInR5cGUiOiJhdXRoIiwiZGV2aWNlVHlwZSI6IndlYiIsImlhdCI6MTc1MzU5NTE5MiwiZXhwIjoxNzUzNjgxNTkyfQ.X9O6mX2RojY0sSYOXOEXQOFrei7vfWKDn7YrQtg1nz0')
    //     //     alert("done")
    //     //     checkCCookie();
    //     // }, 3000)
    //     cookieProvider.set('authToken', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY4ZTY0NjQzOTc0NWUwODk0N2I3NDQwYSIsInR5cGUiOiJhdXRoIiwiZGV2aWNlVHlwZSI6IndlYiIsImlhdCI6MTc2MDE2NjE4MSwiZXhwIjoxNzYwMjUyNTgxfQ.bgRQgq9VJfqowDibUmT9asR5lOCXtrBGeplbLPWeoe4')
    // }
    // useEffect(() => {
    //     updateCookie()
    // }, [])

    // function checkCCookie() {
    //     const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    //     const cCookie = cookies.find(cookie => cookie.startsWith('authToken='));

    //     if (cCookie) {
    //         alert("Cookie 'c' is present: " + cCookie);
    //     } else {
    //         alert("Cookie 'c' is not present.");
    //     }
    // }




    useEffect(() => {
        if (props.activeKey && props.activeKey === "history") {
            if (historyVideos.length === 0) {
                getHistoryVideos();
            } else {
                setIsLoading(false)
            }
        }
    }, [props.activeKey, isLoading]);


    useEffect(() => {
        if (historyVideos.length === 0 && noHistoryRef.current) {
            noHistoryRef.current.style.height = `${window.innerHeight - 120}px`;
        }
    }, [historyVideos])

    const handleLoadMore = () => {
        setVisibleCount((prev) => prev + 4);
    };

    // Flatten videos with their corresponding date
    const flattenedVideos = historyVideos.flatMap((entry: any) =>
        (entry.videos || []).map((video: any) => ({
            ...video,
            date: entry.date,
        }))
    );

    const redirectToVidePage = (video: any) => {
        if (!(video.seriesId || video._id)) {
            console.log("issue in redirectToVidePage");
            return;
        }

        const seriesId = video.seriesId;
        const videoDocId = video._id;
        const isWelcomeSeries = Boolean(
            video.isWelcomeSeries === true || video.isWelcomeOfferVideo === true
        );
        const asSubscribedSeries = Boolean(
            video.isSubscribedSeries === true || video.isSubscribedVideo === true
        );

        let navigate_ = `/watch?video=${videoDocId}`;
        if (seriesId) {
            if (asSubscribedSeries) {
                navigate_ = `/watch?series=${seriesId}`;
                if (videoDocId) {
                    navigate_ += `&video=${videoDocId}`;
                }
                if (isWelcomeSeries) {
                    navigate_ += "&ws=true";
                }
                navigate_ += "&subscription=true";
            } else {
                navigate_ = `/watch?series=${seriesId}&video=${videoDocId}`;
                if (isWelcomeSeries) {
                    navigate_ += "&ws=true";
                }
            }
        }

        navigate(navigate_, {
            state: {
                source: `/`,
                openVideoDirectly: true,
            },
        });
    }

    return (
        <div className={`historyViewMain ${addCurrentThemeClassToEle(currentTheme, 'historyViewMain')}`}>
            {isLoading ? (
                // {true ? ( // testing
                <HistoryFavLoader
                    type="history"
                />
            ) : (
                flattenedVideos.length > 0 ? (
                    <>
                        {flattenedVideos.slice(0, visibleCount).map((video: any, index: number) => (
                            <div key={index}>
                                {(index === 0 || video.date !== flattenedVideos[index - 1].date) && (
                                    <p className='historyVideoDate'>{video.date}</p>
                                )}
                                <div
                                    onClick={() => redirectToVidePage(video)}
                                    className='cursor-pointer flex items-center mb-[25px] max-[1200px]:mb-[20px] max-[450px]:mb-[18px]'>
                                    <img className='hfVideoThumbnail' src={video.thumbnailUrl} alt='historyThumbnail' />
                                    <p className='historyVideoTitle'>{video.title}</p>
                                </div>
                            </div>
                        ))}

                        {visibleCount < flattenedVideos.length && (
                            <div className="flex justify-center my-6">
                                <button
                                    onClick={handleLoadMore}
                                    className="w-[150px] h-[40px] max-[500px]:w-[120px] max-[500px]:h-[30px] text-[16px] max-[500px]:text-[15px] rounded-[5px] loadMoreBtn transition"
                                >
                                    Load More
                                </button>
                            </div>
                        )}
                    </>
                ) : (
                    <div
                        ref={noHistoryRef}
                        className='noHistoryVideoCon text-[#949494] flex items-center justify-center'
                    >
                        <p>{dashboard.historySection.noVideoText}</p>
                    </div>
                )
            )}
        </div>
    );
}
